// Quote-status labels (auto-merged by lib/i18n.ts).
export const en = {
  'quote_status.draft': 'Draft',
  'quote_status.pending': 'Sent',
  'quote_status.confirmed': 'Confirmed',
  'quote_status.booked': 'Booked',
  'quote_status.expired': 'Expired',
  'quote_status.rejected': 'Rejected',
}

export const zhTW = {
  'quote_status.draft': '草稿',
  'quote_status.pending': '已送出',
  'quote_status.confirmed': '已確認',
  'quote_status.booked': '已預訂',
  'quote_status.expired': '已逾期',
  'quote_status.rejected': '已拒絕',
}
